import { ChangedPlanRecord, PlanRecord, PlanRecordType } from "../types"
import { queryCache, useQuery } from "react-query"

import { CellProps } from "components/TreeState"
import { ListCell } from "./ListCell"
import { fetchCopyQualities } from "api/copyQualities"
import { get } from "lodash"
import { set } from "lodash/fp"
import { useBillingTypesRules } from "../useBillingTypeRules"
import { useDefaultFieldIds } from "../useDefaultFieldIds"
import { useSnapshot } from "valtio"
import { useTableSource } from "../TableStateProvider"

export function CopyQualityCell(props: CellProps) {
  const { rowId: id, columnId, dataKey, primaryKey, semantic, disabled } = props
  const tableSource = useTableSource()
  const defaultFieldIds = useDefaultFieldIds(id)
  const readFrom = useSnapshot(tableSource.state)
  const writeTo = tableSource.state

  const type = readFrom[id]?.type as PlanRecordType
  const isMediaSubmedia =
    type === "media_type_plan" || type === "media_subtype_plan"

  const readonly = disabled

  const action = readFrom[id]?.action
  const selected = get(readFrom[id], `${dataKey}.id`) as string
  const updatable = !action || action === "UPDATE_ORDER"

  const { data: copyQualities } = useQuery(
    "copy-qualities",
    fetchCopyQualities,
    {
      enabled: !queryCache.getQueryData("copy-qualities"),
    },
  )

  const options = copyQualities?.map((c) => ({
    value: c.id,
    label: c.name,
    disabled: c.status !== "ACTIVE",
  }))

  // apply billing type rules
  const viewable = useBillingTypesRules(
    readFrom[id] as ChangedPlanRecord,
    primaryKey,
    semantic,
  )
  if (!viewable || isMediaSubmedia) return <span />

  const onChange = (value?: string) => {
    const { copyFactor } = defaultFieldIds || {}
    const updatedMediaFields: PlanRecord["planningMediaFields"] =
      writeTo[id]?.[primaryKey as "planningMediaFields"] || {}

    // write the selected copy
    updatedMediaFields[columnId] = value ? { id: value } : null

    // get the selected copy quality resource
    const copyQuality = copyQualities?.find((cq) => cq.id === value)

    // populate the factor
    !!copyFactor &&
      (updatedMediaFields[copyFactor] = copyQuality?.factor || null)

    writeTo[id] = set(primaryKey, updatedMediaFields, writeTo[id])
    updatable && (writeTo[id] = set("action", "UPDATE", writeTo[id]))
  }

  return (
    <ListCell
      {...props}
      bulkDisabled={true}
      options={options}
      onChange={onChange}
      selected={selected}
      disabled={readonly}
      dataKey={dataKey}
    />
  )
}
